"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PardonAbilityHandler = exports.PardonActorAbilityFactory = exports.PardonAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class PardonAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Pardon;
        this.__typeName = "Pardon";
    }
}
exports.PardonAbilityArgs = PardonAbilityArgs;
let PardonActorAbilityFactory = class PardonActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Pardon", "OneAllies", 1);
    }
};
PardonActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Pardon")
], PardonActorAbilityFactory);
exports.PardonActorAbilityFactory = PardonActorAbilityFactory;
let PardonAbilityHandler = class PardonAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAlly] = ability.args.target.actorIds;
        const target = container.hasAttribute(ability.invokerId, "Charm_Executioner_0") ? Target_1.Target.AllAllies
            : Target_1.Target.Any([selectedAlly]);
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                container.removeDebuffs({
                    sequence,
                    removerId: ability.invokerId,
                    targets: container.selectLivingTargets(ability.invokerId, target)
                        .map(targetId => ({
                        targetId,
                        onDebuffsRemoved: sequence => {
                            sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "BeamFromTheHeavens"));
                        }
                    }))
                });
            }
        });
    }
};
PardonAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Pardon)
], PardonAbilityHandler);
exports.PardonAbilityHandler = PardonAbilityHandler;
